document.addEventListener('submit', event => {
    let formData;
    let urlParameters;
    let sectionId;
    let noticeMessages;
    let translationKeys;
    const profileGetFormIdPrefix       = 'profileGetForm';
    const emailPreferencesFormIdPrefix = 'emailPreferencesForm';
    const formId = event.target.attributes.id?.value;
    
    if ([profileGetFormIdPrefix, emailPreferencesFormIdPrefix ]
        .some(idPrefix => formId?.startsWith(idPrefix))) {
        event.preventDefault();
        toggleLoading(event.target);
        formData       = new FormData(event.target);
        urlParameters  = new URLSearchParams(formData.entries());
        sectionId      = event.target.closest('section').dataset.parentSectionId;
        noticeMessages = parseTranslations("{&quot;success_header&quot; =&gt; &quot;Success!&quot;, &quot;success_message&quot; =&gt; &quot;Your marketing preferences have been updated&quot;, &quot;failure_header&quot; =&gt; &quot;Request failed&quot;, &quot;generic_failure_message_html&quot; =&gt; &quot;Sorry, something went wrong. We&#39;ve been notified of the problem and are working on it. If you need immediate assistance, please reach out to &lt;a href=&#39;/pages/contact-us&#39;&gt;our support team&lt;/a&gt;.&quot;, &quot;404_message&quot; =&gt; &quot;Sorry, we couldn&#39;t find that email. Ensure your email is typed correctly and try resubmitting.&quot;, &quot;no_js_message&quot; =&gt; &quot;Sorry, JavaScript must be enabled to use this form. If you&#39;re unable to use JavaScript, please reach out to &lt;a href=&#39;/pages/contact-us&#39;&gt;our support team!&lt;/a&gt;.&quot;}");
        translationKeys = {
            notFound: '404_message',
            generic:  'generic_failure_message_html',
        }
    }

    if (formId?.startsWith(profileGetFormIdPrefix)) {
        // event.target is the profileGetForm
        let getProfileSection       = event.target.closest('section');
        let emailPreferencesSection = document.getElementById(`${emailPreferencesFormIdPrefix}-section-${sectionId}`)
        let emailPreferencesForm    = emailPreferencesSection.querySelector(`#${emailPreferencesFormIdPrefix}-${sectionId}`);

        urlParameters.append(
            'filter',
            `equals(email,"${urlParameters.get('email')}")`
        );
        urlParameters.append(
            'fields[profile]',
            'email,first_name,last_name,location.zip,properties'
        );
        urlParameters.delete('email');
        
        fetch(`https://klaviyoproxy.pssl.workers.dev/profiles/?${urlParameters.toString()}`)
            .then(response => {
                if (!response.ok) {
                    let key = response.status === 404 ? translationKeys.notFound : translationKeys.generic;
                    throw new Error(noticeMessages[key]);
                }

                return response.json();
            })
            .then(data => {
                data = data.data?.[0];

                if (data) {                   
                    const properties = data?.attributes?.properties;
                    let attributeLabels = parseTranslations("{&quot;EmailPrefContests&quot; =&gt; &quot;Contests&quot;, &quot;EmailPrefKillerDailyDeals&quot; =&gt; &quot;Killer Daily Deals&quot;, &quot;EmailPrefNewGearAlerts&quot; =&gt; &quot;New Gear Alerts&quot;, &quot;EmailPrefPriceCuts&quot; =&gt; &quot;Price Cuts&quot;, &quot;EmailPrefSoCalLocalDeals&quot; =&gt; &quot;SoCal Local Deals&quot;, &quot;EmailPrefTechCorner&quot; =&gt; &quot;Tech Corner&quot;, &quot;EmailPrefWeeklyDeals&quot; =&gt; &quot;Weekly Deals&quot;, &quot;GearPrefAccessories&quot; =&gt; &quot;Accessories&quot;, &quot;GearPrefGuitarAndBass&quot; =&gt; &quot;Guitar &amp; Bass&quot;, &quot;GearPrefKeyboardsAndProduction&quot; =&gt; &quot;Keyboards &amp; Production&quot;, &quot;GearPrefLighting&quot; =&gt; &quot;Lighting&quot;, &quot;GearPrefProAudio&quot; =&gt; &quot;Pro Audio&quot;, &quot;GearPrefStudioAndRecording&quot; =&gt; &quot;Studio and Recording&quot;, &quot;GearPrefDJGear&quot; =&gt; &quot;DJ Gear&quot;}")

                    emailPreferencesForm.querySelector(`#${emailPreferencesFormIdPrefix}-profileId-${sectionId}`).value   = data?.id;
                    emailPreferencesForm.querySelector(`#${emailPreferencesFormIdPrefix}-email-${sectionId}`).value       = data?.attributes?.email;
                    emailPreferencesForm.querySelector(`#${emailPreferencesFormIdPrefix}-last-name-${sectionId}`).value   = data?.attributes?.last_name;
                    emailPreferencesForm.querySelector(`#${emailPreferencesFormIdPrefix}-first-name-${sectionId}`).value  = data?.attributes?.first_name;
                    emailPreferencesForm.querySelector(`#${emailPreferencesFormIdPrefix}-postal-code-${sectionId}`).value = data?.attributes?.location?.zip;

                    if (Object.keys(properties)) {
                        for (const property in data.attributes.properties) {
                            if (Object.hasOwnProperty.call(data.attributes.properties, property)) {
                                const value         = data.attributes.properties[property];
                                const isLanguage    = property === 'Language Preference';
                                const formElementId = `${emailPreferencesFormIdPrefix}-${property}-${sectionId}`;

                                let label = attributeLabels[property] ?? value;
                                let selector;

                                if (property.startsWith('Email')) {
                                    if (["EBLAST00KILLERDD"].includes(label)) continue;
                                    selector = '[id^="emailPreferencesForm-list"]';
                                }
                                if (property.startsWith('Gear'))  {
                                    if (["true"].includes(label)) continue;
                                    selector = '[id^="emailPreferencesForm-gear"]';
                                }
                                if (isLanguage) selector = '[id^="emailPreferencesForm-language"]';

                                if (selector) {
                                    if (isLanguage) {
                                        const languageArray = JSON.parse(value);
                                        let englishPreferred = true;
                                        let spanishPreferred = false;

                                        if (
                                            Array.isArray(languageArray) && 
                                            languageArray.length === 1       && 
                                            languageArray.includes("Spanish")
                                        ) {
                                            englishPreferred = false
                                            spanishPreferred = true;
                                        }

                                        emailPreferencesForm.querySelector(selector)
                                            .insertAdjacentHTML(
                                                'beforeend',
                                                `<label
                                                    for="${formElementId}"
                                                    class=""
                                                >
                                                    <input
                                                        type="radio"
                                                        id="${formElementId}"
                                                        name="attributes[properties][${property}]"
                                                        value="English"
                                                        ${englishPreferred && "checked"}
                                                        
                                                    >
                                                    <span aria-hidden="true">English</span>
                                                </label>
                                                <label
                                                    for="${formElementId}"
                                                    class=""
                                                >
                                                    <input
                                                        type="radio"
                                                        id="${formElementId}"
                                                        name="attributes[properties][${property}]"
                                                        value="Spanish"
                                                        ${spanishPreferred && "checked"}
                                                    >

                                                    <span aria-hidden="true">Spanish</span>
                                                </label>`
                                            );
                                    } else {
                                        emailPreferencesForm.querySelector(selector)
                                            .insertAdjacentHTML(
                                                'beforeend',
                                                createAttributeCheckboxInput(
                                                    formElementId,
                                                    property,
                                                    value,
                                                    label
                                                )
                                            );
                                    }
                          
                                }
                            }
                        }

                        getProfileSection.style.display       = 'none';
                        emailPreferencesSection.style.display = 'block';

                        emailPreferencesForm.querySelector('input').focus();
                    }
                } else {
                    throw new Error(noticeMessages[translationKeys.notFound]);
                }
            })
            .catch(error => errorHandler(error, event.target, noticeMessages))
            .finally(() => toggleLoading(event.target))
    }

    if (formId?.startsWith(emailPreferencesFormIdPrefix)) {
        fetch(
            `https://klaviyoproxy.pssl.workers.dev/profiles/${event.target.querySelector(`#${emailPreferencesFormIdPrefix}-profileId-${sectionId}`).value}`,
            {
                body:   JSON.stringify(formDataToObject(new FormData(event.target))),
                method: 'PATCH'
            }
        )
        .then(response => {
            if (!response.ok) throw new Error(noticeMessages[translationKeys.generic]);

            return response.json();
        })
        .then(data => {
            if (data?.errors) throw new Error(noticeMessages[translationKeys.generic]);
            successHandler(event.target, noticeMessages);
            return;
        })
        .catch(error => errorHandler(error, event.target, noticeMessages))
        .finally(() => {
            toggleLoading(event.target)
            event.target.scrollIntoView();
        })
    }
});

function successHandler(form, noticeMessages){
    form.querySelector('h2[role="alert"] [data-message-component="text"]')
        .innerText = noticeMessages['success_header'];
    form.querySelector('p[role="alert"]')
        .innerText = noticeMessages['success_message'];

    form.querySelectorAll('[role="alert"]').forEach(element => {
        let formMessage = element.closest('.form__message');
        let errorIcon   = formMessage.querySelector('.icon-success');

        if (formMessage) formMessage.style.display = 'block';
        if (errorIcon)   errorIcon.style.display   = 'inline-block';
    });
}

function errorHandler(error, form, noticeMessages){
    console.error(error);

    let errorMessageElement = form.querySelector('p[role="alert"]');
    form.querySelector('h2[role="alert"] [data-message-component="text"]')
        .innerText = noticeMessages['failure_header'];

    let message = error.message === 'Failed to fetch' ? noticeMessages['generic_failure_message_html'] : error.message;
    errorMessageElement.innerHTML = message;

    form.querySelectorAll('[role="alert"]').forEach(element => {
        let formMessage = element.closest('.form__message');
        let errorIcon   = formMessage.querySelector('.icon-error');

        if (formMessage) formMessage.style.display = 'block';
        if (errorIcon)   errorIcon.style.display   = 'inline-block';
    });
}

function toggleLoading(form){
    let spinner          = form.querySelector('.loading-overlay__spinner');
    let spinnerMessage   = spinner.closest('.form__message');
    let elementsToToggle = [
        spinnerMessage,
        ...Array.from(spinnerMessage.querySelectorAll('.form__message'))
    ];

    if (!spinnerMessage.style.display || spinnerMessage.style.display === 'none') { 
        elementsToToggle.forEach(element => element.style.display = 'flex');
    } else {
        elementsToToggle.forEach(element => element.style.display = 'none');
    }

    spinner.classList.toggle('hidden');
}

function createAttributeCheckboxInput(formElementId, property, value, label){
    if (typeof value === "string") value = value.toLowerCase() === "true";

    return  `<label
                for="${formElementId}"
                class="facet-checkbox"
            >
                 <input
                    type="hidden"
                    id="${formElementId}-default"
                    name="attributes[properties][${property}]"
                    value="false"
                >

                <input
                    type="checkbox"
                    id="${formElementId}"
                    name="attributes[properties][${property}]"
                    value="true"
                    ${value && "checked"}
                >

                <svg
                    width="1.6rem"
                    height="1.6rem"
                    viewBox="0 0 16 16"
                    aria-hidden="true"
                    focusable="false"
                >
                    <rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>
                </svg>

                <svg
                    aria-hidden="true"
                    class="icon icon-checkmark"
                    width="1.1rem"
                    height="0.7rem"
                    viewBox="0 0 11 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1"
                        stroke="currentColor"
                        stroke-width="1.75"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>

                <span aria-hidden="true">${label}</span>
            </label>`;
}

function parseTranslations(string) {
    if (!string) return;

    return JSON.parse(
        new DOMParser()
            .parseFromString(
                string,
                'text/html'
            )
            .documentElement.textContent
                .replaceAll('=>', ':')
    );
}

function formDataToObject(formData){
    const result = { data: {} };

    for (let [key, value] of formData.entries()) {
        const keys = key.match(/[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*/g);
        let current = result.data;

        for (let i = 0; i < keys.length - 1; i++) {
            const k = keys[i];
            if (!(k in current)) current[k] = {};
            current = current[k];
        }

        if (key === "attributes[properties][Language Preference]") {
            value = JSON.stringify([value]);
        }

        current[keys[keys.length - 1]] = value;
    }

    return result;
};